import { render, staticRenderFns } from "./RpdDoubleSlider.vue?vue&type=template&id=3f0646c4&scoped=true"
import script from "./RpdDoubleSlider.vue?vue&type=script&lang=js"
export * from "./RpdDoubleSlider.vue?vue&type=script&lang=js"
import style0 from "./RpdDoubleSlider.vue?vue&type=style&index=0&id=3f0646c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0646c4",
  null
  
)

export default component.exports